import React, { Fragment, useContext } from 'react';
import classes from './OnboardingSteps.module.scss';
import { OnboardingContext } from '../states/OnboardingProvider';
import { OnboardingStep } from '../OnboardingStep';
import { OnboardingStepViewProps } from '../OnboardingStep/OnboardingStepView';
import classNames from 'classnames';
import { Icon } from '../../../components/images/Icon/Icon';
import { IconsEnum } from '../../../constants/icons';

export type OnboardingStepsViewProps = {
  className?: string;
};

export const OnboardingStepsView = (props: OnboardingStepsViewProps): JSX.Element => {
  const { className } = props;
  const { state } = useContext(OnboardingContext);
  const { progress } = state;

  return (
    <div className={classNames('grid-x align-middle', className)}>
      {progress.map((step, index) => {
        const isLast = progress.length - 1 === index;
        const props: OnboardingStepViewProps = {
          step,
          index
        };
        return (
          <Fragment key={step.key}>
            <div className={'cell shrink'}>
              <OnboardingStep {...props} />
            </div>
            {!isLast && (
              <div className={classNames('cell', 'shrink', classes.OnboardingStepMarker)}>
                <Icon name={IconsEnum.arrowRight} size={'medium'} />
              </div>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};
